import type { BannerProps } from '@shopify/polaris';

import { Card, Banner } from '@shopify/polaris';

/**
 * GBannerCard - Banner component displayed in card format without external card wrapper
 * Use when you want banner to have card appearance but don't need separate card wrapper
 */
interface GBannerCardProps extends BannerProps {
  children?: React.ReactNode;
}
export const GBannerCard = ({ children, ...props }: GBannerCardProps) => {
  return (
    <div className="GBannerCard">
      <Card padding={'0'}>
        <Banner {...props}>{children}</Banner>
      </Card>
    </div>
  );
};
